export class EmbedToken {
    constructor(
        public expiration: string = ``,
        public token: string = ``,
        public tokenId: string = ``
    ) { }
}